export default __webpack_public_path__ + "static/media/1150.66624166.png";